<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title class="title font-weight-medium">
        Histórico de veículos
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="my-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-autocomplete
                  v-model="selectedVehicle"
                  :items="vehicles"
                  :search-input.sync="getVehicleHistory"
                  item-text="text"
                  item-value="value"
                  label="Selecionar veículo"
                  no-data-text="Nenhum veículo encontrado"
                  prepend-icon="mdi-car"
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-flex class="mx-3 my-2" xs12 md12>
          <v-row justify="start">
            <v-col align="start">
              <v-data-table
                class="elevation-0 mt-2"
                :headers="headers"
                :items="vehicleHistory"
                :footer-props="{
                  'items-per-page-text': 'Linhas por página:',
                }"
                :no-data-text="
                  selectedVehicle
                    ? 'Não existe histórico para o veículo selecionado'
                    : 'Selecione um veículo para exibir o histórico'
                "
                item-key="name"
                group-key="category"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.vehicle.plate }}</td>
                    <td>{{ item.previous_client.name }}</td>
                    <td>{{ item.new_client.name }}</td>
                    <td>{{ item.updatedBy.name }}</td>
                    <td>{{ item.updated_at | formatDate }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import VehicleController from '../../controllers/VehicleController';
import VehicleHistoryController from '../../controllers/VehicleHistoryController';

export default {
  data() {
    return {
      blockScreen: false,
      blockScreenData: blockScreenUi.blockScreenData,

      vehicleController: new VehicleController(this.$resource),
      vehicleHistoryController: new VehicleHistoryController(this.$resource),

      vehicles: [],
      vehicleHistory: [],
      selectedVehicle: null,
      previousSelectedVehicle: null,
      getVehicleHistory: null,
      headers: [
        { text: 'Veículo', value: 'vehicle.plate' },
        { text: 'Cliente Antigo', value: 'previous_client.name' },
        { text: 'Cliente Novo', value: 'new_client.name' },
        { text: 'Atualizado por', value: 'updatedBy.name' },
        { text: 'Atualizado em', value: 'created_at' },
      ],
    };
  },

  created() {
    this.getVehicles();
  },

  methods: {
    async getVehicles() {
      this.blockScreen = true;
      try {
        const vehicles = await this.vehicleController.getAllVehicles();

        vehicles.forEach(vehicle => {
          const { id, plate, vehicle_model, client } = vehicle;

          this.vehicles.push({
            text: `${plate} - ${vehicle_model.model} - ${
              vehicle_model.brand
            } - ${client != null ? client.name : 'Sem cliente'}`,
            value: id,
          });
        });
      } catch (err) {
        this.$awn.alert(err, 'Falha ao obter veículos');
      } finally {
        this.blockScreen = false;
      }
    },
  },

  watch: {
    async getVehicleHistory() {
      if (
        !this.selectedVehicle ||
        this.previousSelectedVehicle === this.selectedVehicle
      )
        return;

      this.previousSelectedVehicle = this.selectedVehicle;

      this.blockScreen = true;

      try {
        this.vehicleHistory = await this.vehicleHistoryController.getByVehicleId(
          this.selectedVehicle
        );
      } catch (error) {
        return this.$awn.alert('Erro ao obter histórico do veículo ' + error);
      } finally {
        this.blockScreen = false;
      }
    },
  },

  filters: {
    formatDate(date) {
      if (date) {
        return moment(date).format('DD[/]MM[/]YYYY HH:mm');
      }
    },
  },
};
</script>
